export default "__VITE_ASSET__BhwogTC$__"